import { LitElement, html, css } from 'lit-element';
import { styleMap } from 'lit-html/directives/style-map.js';
import dayjs from 'dayjs';
import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
// not sure this is the best way..
import { getRouter } from '../routing/route-base';
import { SELECT_MODES } from '../table/table-constants';
import { DETAIL_MODES } from '../form/constants';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-switch';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-tooltip';
import '../table/tmn-table-editable';
import './reset-password-btn';
import './act-as-btn';
import './user-detail';
import './user-detail-bulk-edit';
import '../util/loading-logo';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
const { CAN_EDIT_USERS, CAN_SEE_USER_IDS } = AUTHORIZATIONS;

const dateFormatFn = (value, row) => {
    return value
        ? html`${dayjs(value).format('YYYY-MM-DD')}`
        : html`<div style="text-align:center">-</div>`;
};

class UserList extends LitElement {
    constructor() {
        super();
        this.allUsers = [];
        this._columnDefs = [];
        this.resetPassword = this.resetPassword.bind(this);
        this.actAs = this.actAs.bind(this);
    }

    static get styles() {
        // can be shared with site or more general table component maybe?
        return [
            css`
                :host {
                    --table-cell-height: 36px;
                }
                .message-wrapper {
                    display: flex;
                    margin-top: 150px;
                    align-items: center;
                    justify-content: center;
                }
                .message-wrapper .message {
                    border-radius: 8px;
                    padding: 40px;
                    font-size: 20px;
                    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
                        rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
                }
            `,
            css`
                .user-inactive {
                    color: rgba(0, 0, 0, 0.1);
                }
                .user-active {
                    color: var(--app-primary-color);
                }
                .table-container {
                    height: calc(100% - 55px);
                }
            `,
        ];
    }

    static get properties() {
        return {
            allUsers: {
                type: Array,
            },
            activeAuthSite: {
                type: String,
            },
            activeAuthSiteId: {
                type: String,
            },
            _columnDefs: {
                type: Array,
            },
            selectedUsersIds: {
                type: Array,
            },
            detailMode: {
                type: String,
            },
            // todo make this more general purpose filters
            showInactive: {
                type: Boolean,
            },
            accountName: {
                type: String,
            },
            authorizations: {
                type: Array,
            },
            isActiveRecordDirty: {
                type: Boolean,
            },
            isUserAdminReady: {
                type: Boolean,
            },
            selectMode: {
                type: String,
            },
            isMobile: {
                type: Boolean,
            },
        };
    }
    // todo loading here too
    updated(changedProps) {
        if (changedProps.has('activeAuthSite') || changedProps.has('isMobile')) {
            const { activeAuthSite, authorizations, isMobile } = this;
            if (authorizations.includes(CAN_EDIT_USERS)) {
                this.actions.fetchUserConfigTemplates();
            }
            this.actions.fetchUserList();
            this._columnDefs = [
                {
                    label: 'Name',
                    key: 'display_name',
                    sortable: true,
                    search: true,
                    hideInDetailMode: false,
                    // dataFormatter: (name, row) => {
                    //     const id = row.metaData.id;
                    //     const data = { eUserId: id, authSite: activeAuthSite };
                    //     return html`<routed-link .data=${data} name="user-detail"
                    //         >${name}</routed-link
                    //     >`;
                    // },
                },
                {
                    key: 'user_type',
                    label: 'Type',
                    sortable: true,
                    search: true,
                    hideInDetailMode: true,
                },
                {
                    key: 'username',
                    label: 'Username',
                    sortable: true,
                    search: true,
                    hideInDetailMode: isMobile,
                },
                {
                    key: 'expiration_date',
                    label: 'Expiration',
                    sortable: true,
                    search: true,
                    hideInDetailMode: false,
                    dataFormatter: dateFormatFn,
                },
                {
                    key: 'sponsor',
                    label: 'Sponsor',
                    sortable: true,
                    search: true,
                    hideInDetailMode: true,
                },
                {
                    key: 'comment',
                    label: 'Comment',
                    sortable: true,
                    search: true,
                    hideInDetailMode: true,
                    dataFormatter: (value, row) => {
                        // todo sort out formatter options/styles, maybe do like tmn-table-render
                        const commentStyle = styleMap({
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '180px',
                            whiteSpace: 'nowrap',
                        });

                        return value ? html`<div style=${commentStyle}>${value}</div>` : null;
                    },
                },
                {
                    // consider if this should be a special type
                    key: '_',
                    label: '',
                    hideInDetailMode: true,
                    dataFormatter: (value, row) => {
                        return this.renderActions(row);
                    },
                },
                {
                    key: 'updated',
                    label: 'Updated',
                    sortable: true,
                    search: true,
                    hideInDetailMode: true,
                    dataFormatter: dateFormatFn,
                },
                {
                    key: 'active',
                    label: 'Active',
                    sortable: true,
                    hideInDetailMode: false,
                    dataFormatter: (value, row) => {
                        // todo sort out formatter options/styles, maybe do like tmn-table-render
                        // but see if there is a better technique now
                        const iconStyle = styleMap({
                            color: value ? 'var(--app-primary-color)' : 'rgba(0, 0, 0, 0.1)',
                            textAlign: 'center',
                        });
                        return value
                            ? html`<div style=${iconStyle}>
                                  <tmn-icon
                                      class="user-active"
                                      icon="check_circle_outline"
                                      iconvariant="outlined"></tmn-icon>
                              </div>`
                            : html`<div style=${iconStyle}>
                                  <tmn-icon
                                      class="user-inactive"
                                      icon="circle"
                                      iconvariant="outlined"></tmn-icon>
                              </div>`;
                    },
                },
            ];
            if (authorizations.includes(CAN_SEE_USER_IDS)) {
                this._columnDefs.unshift({
                    key: 'userId',
                    label: 'Id',
                    sortable: true,
                    search: false, // todo need to make this work as a string in search
                    hideInDetailMode: true,
                });
            }
        }
    }

    render() {
        const { activeAuthSite, isActiveRecordDirty, isUserAdminReady } = this;

        if (activeAuthSite) {
            if (!isUserAdminReady) {
                return this.renderLoading();
            }
            return this.renderTable();
        }
        return this.renderSiteSelect();
    }

    renderLoading() {
        return html`<loading-logo></loading-logo>`;
    }

    renderActions(row) {
        // could maybe make this more integrated so we wouldn't have to do stuff like this?
        const actionStyle = styleMap({
            whiteSpace: 'nowrap',
            position: 'relative',
        });

        const { accountName, activeAuthSiteId } = this;
        //const displayName = row.data[0];
        const displayName = row?.metaData?.rawData?.display_name;
        return html`<div style=${actionStyle}>
            <act-as-btn
                name="act-as"
                .displayName=${accountName}
                .eventData=${row}
                .eSiteId=${activeAuthSiteId}
                @click=${this.stopPropagation}
                @tmn-act-as-confirmed=${this.actAs}>
            </act-as-btn>
            <reset-password-btn
                name="reset-pw"
                .displayName=${displayName}
                .eventData=${row}
                @click=${this.stopPropagation}
                @tmn-reset-password-confirmed=${this.resetPassword}>
            </reset-password-btn>
        </div>`;
    }

    // needed to avoid triggering the row click
    stopPropagation(e) {
        if (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
    }

    // cleanupToolTips(e) {
    //     const tooltips = e.target?.parentElement.querySelectorAll('tmn-tooltip');
    //     if (e) {
    //         e.stopImmediatePropagation();
    //         e.stopPropagation();
    //         e.preventDefault();
    //     }
    //     tooltips.forEach((tooltip) => {
    //         if (tooltip) {
    //             tooltip.hide();
    //         }
    //     });
    // }

    resetPassword(e) {
        const { detail } = e;
        const params = { eUserId: detail?.metaData?.id };
        this.actions.resetPassword(params);
    }

    actAs(e) {
        if (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
        const { detail } = e;
        const params = { eUserId: detail?.metaData?.id };
        this.actions.actAsUser(params);
    }

    renderTable() {
        const {
            allUsers,
            _columnDefs,
            selectedUsersIds,
            detailMode,
            isActiveRecordDirty,
            showInactive = false,
            selectMode,
            isMobile,
        } = this;
        const _selectMode = detailMode === DETAIL_MODES.NEW ? SELECT_MODES.NONE : selectMode;
        return html`
            <div class="table-container">
                <tmn-table-editable
                    @tmn-row-select-toggle=${this.handleRowSelectToggle}
                    @tmn-table-editable-add-new=${this.handleNewUser}
                    @tmn-table-editable-close-details=${this.handleCancelUserOperation}
                    .useFilters=${false}
                    .rowIdentifier=${'eUserId'}
                    .dataRows=${allUsers}
                    .selectedRowIds=${selectedUsersIds}
                    .detailMode=${detailMode}
                    .selectMode=${_selectMode}
                    .shouldConfirmOnClose=${isActiveRecordDirty}
                    .shouldConfirmOnNavigate=${isActiveRecordDirty}
                    .confirmMessage=${'The selected user record appears to have changes.  If you continue without saving the changes will be lost.'}
                    .columnDefs=${_columnDefs}>
                    <div slot="right-actions">
                        <tmn-switch
                            .checked=${showInactive}
                            color="primary"
                            @tmn-switch-change=${this.toggleActiveStatus}>
                            Show Inactive
                        </tmn-switch>
                        ${isMobile
                            ? null
                            : html`<tmn-switch
                                  .checked=${_selectMode === SELECT_MODES.MULTI}
                                  color="primary"
                                  @tmn-switch-change=${this.toggleSelectionMode}>
                                  Bulk Edit
                              </tmn-switch>`}
                    </div>
                    ${this.renderDetail()}
                </tmn-table-editable>
            </div>
        `;
    }

    renderDetail() {
        if (this.selectMode === SELECT_MODES.MULTI) {
            return html`<user-detail-bulk-edit slot="detail"></user-detail-bulk-edit>`;
        }
        return html`<user-detail slot="detail"></user-detail>`;
    }

    renderSiteSelect() {
        const { availableAuthSites } = this;
        return html`<div class="message-wrapper">
            <div class="message">Select a site to display users</div>
        </div>`;
    }

    handleNewUser(e) {
        const { activeAuthSite } = this;
        const router = getRouter();
        router.navigateByName('user-new', { authSite: activeAuthSite });
    }

    toggleActiveStatus(e) {
        this.actions.setUserFilters({
            showInactive: !this.showInactive,
        });
    }

    toggleSelectionMode(e) {
        // todo handle edge cases etc
        let newSelectMode = SELECT_MODES.SINGLE;
        if (this.selectMode === SELECT_MODES.SINGLE) {
            newSelectMode = SELECT_MODES.MULTI;
        }
        this.actions.setUserSelectMode({
            selectMode: newSelectMode,
        });
    }

    handleCancelUserOperation() {
        this.actions.cancelUserChanges();
    }

    handleRowSelectToggle(e) {
        const { selectMode, detailMode } = this;
        if (detailMode === DETAIL_MODES.NEW) {
            return;
        }
        if (selectMode === SELECT_MODES.SINGLE) {
            this.handleSingleEditRowToggle(e);
        }
        if (selectMode === SELECT_MODES.MULTI) {
            this.handleBulkEditRowToggle(e);
        }
    }

    handleSingleEditRowToggle(e) {
        const { activeAuthSite } = this;
        const { selected, id } = e.detail;
        const router = getRouter();
        if (selected) {
            router.navigateByName('user-detail', { eUserId: id, authSite: activeAuthSite });
        } else {
            router.navigateByName('user-list', { authSite: activeAuthSite });
        }
    }

    handleBulkEditRowToggle(e) {
        const { activeAuthSite } = this;
        const { selected, id } = e.detail;
        if (selected) {
            this.actions.selectUser({ eUserId: id });
        } else {
            this.actions.unselectUser({ eUserId: id });
        }
        // essentially just reset url to user-list (in case we had a detail selected) but don't refresh the
        const router = getRouter();
        router.navigateByName('user-list', { authSite: activeAuthSite }, { callHandler: false });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const filters = selectors.userListFiltersSelector(state);
        const showInactive = filters?.showInactive;
        return {
            allUsers: selectors.userListSelector(state),
            activeAuthSite: selectors.activeAuthSiteNameSelector(state),
            activeAuthSiteId: selectors.activeAuthSiteIdSelector(state),
            selectedUsersIds: selectors.selectedUserIdsSelector(state),
            detailMode: selectors.userDetailModeSelector(state),
            accountName: accountSelectors.userAccountSelector(state)?.displayName,
            isActiveRecordDirty: selectors.isActiveRecordDirty(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            isUserAdminReady: selectors.isUserAdminReadySelector(state),
            selectMode: selectors.userSelectMode(state),
            showInactive,
        };
    };
};

const combinedActions = {
    ...actions,
};
customElements.define('user-list', connect(mapStateToProps, combinedActions)(UserList));
// todo this is experimental, move when/if it works out
class TableWidthRestricted extends LitElement {
    constructor() {}

    static get styles() {
        return [
            css`
                /* :host {
                } */
                .error-message {
                    max-width: var(--table-cell-max-width, 400px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            `,
        ];
    }

    static get properties() {
        return {
            msg: {
                type: String,
            },
            isError: {
                type: Boolean,
            },
        };
    }
    updated(changedProps) {}
    render() {
        return html`<div class="error">${this.msg}</div>`;
    }
}

customElements.define('cell-max-width', TableWidthRestricted);
